import React from 'react';
import './Footer.css';

import { Logo, Newsletter } from '../../components'; // Importing the Logo and Newsletter components
import { contactContent, services } from '../../constants'; // Importing contact information and services data

// Importing necessary icons from react-icons
import { FaHammer, FaFacebookF, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { FaXTwitter } from "react-icons/fa6";

// Importing Link for navigation
import { Link } from 'react-router-dom';



const Footer = () => {

  return (
    <footer className='footer'>

      <div className='box-container'>

        {/* About Section */}
        <div className='footer-item'>

          <Logo /> {/* Display the Logo component */}
          <p>Crafting bespoke woodwork solutions for your home and business needs.</p> {/* Description for the about section */}

          <div className='info connect'>
            {contactContent
              .filter(contact => contact.id !== 4) // Exclude the contact with id: 4
              .map((contact) => {
                return (
                  <div key={contact.id} className='connect-item'>
                    <div className='icon'>{contact.icon}</div>
                    <span>{contact.content[0]}</span>
                  </div>
                );
              })
            }
          </div>

          {/* Social media icons with links */}
          <div className='social'>
            <a href="/#"><FaFacebookF className='icon' /></a>
            <a href="/#"><FaXTwitter className='icon' /></a>
            <a href="/#"><FaInstagram className='icon' /></a>
            <a href="/#"><FaLinkedin className='icon' /></a>
          </div>

        </div>

        {/* Services Links Section */}
        <div className='footer-item'> 

          <h2>Our Services</h2>

          <div className='info links'> 
            {/* Mapping through the services and creating links to each service page */}
            {services.map(service => {
              /* Link to the individual service page */
              return <p key={service.id}><FaHammer className='icon' /> 
                <Link
                  to={{ 
                    pathname: '/Services/' + service.title, // Dynamically constructing the link path
                  }}
                  location={{service}} // Passing service data to the route
                  state={service} // Passing service data in state
                >
                  {service.title}  {/* Display Service Title */}
                </Link>
              </p>
            })}
          </div>
        </div>

        {/* Useful Links Section */}
        <div className='footer-item'>

          <h2>Quick Links</h2>

          {/* Links for easy navigation to various pages */}
          <div className='info links'> 
            <p><FaHammer className='icon' /><Link to='/About-us'>about Us</Link></p>
            <p><FaHammer className='icon' /><Link to='/Pricing'>Pricing</Link></p>
            <p><FaHammer className='icon' /><Link to='/Get-Quote'>Get Quote</Link></p>
            <p><FaHammer className='icon' /><Link to='/Projects'>Projects</Link></p>
            <p><FaHammer className='icon' /><Link to='/Blog-grid'>Blogs</Link></p>
            <p><FaHammer className='icon' /><Link to='/Contact-us'>contact</Link></p>
          </div>

        </div>

        {/* Newsletter Section */}
        <div className='footer-item'>

          <h2>Newsletter</h2>
          <p>Stay informed and up-to-date with the latest trends, insightful articles, helpful tips, and exclusive special offers tailored to the world of woodwork and carpentry.</p> {/* Description for the Newsletter section */}

          {/* Newsletter component to subscribe */}
          <Newsletter variant='dark' idPrefix='2' />

        </div>

      </div>

      <div className='content'>

        {/* Footer content with copyright information */}
        <p>&copy; TimberCraft 2025 All Rights Reserved</p>

      </div>

    </footer>
  )
}

export default Footer;